class ProductAddToCart extends HTMLElement {
  connectedCallback() {
    if (this.initialised) return;
    this.initialised = true;

    this.price = this.querySelector('[data-atc-price]');
    this.priceWrapper = this.querySelector('[data-atc-price-wrapper]');
    this.compare = this.querySelector('[data-atc-compare]');
    this.button = this.querySelector('button[name="add"]');
    this.label = this.querySelector('[data-atc-label]');
    this.variantInput = this.querySelector('[data-atc-variant-input]');
    this.addLabel = this.dataset.addLabel || this.label?.textContent.trim();

    this.addEventListener('product-kit:change', () => this.render());

    try {
      this.variants = JSON.parse(this.dataset.variants || '{}');
    } catch {
      this.variants = {};
    }

    this.picker = document.querySelector('variant-radios');
    this.onVariantChange = this.onVariantChange.bind(this);
    this.picker?.addEventListener('change', this.onVariantChange);

    this.applyTestPrice();
    this.render();

    /* ABConvert may not have assigned a test group yet - check again once the page has loaded. */
    if (document.readyState !== 'complete') {
      this.onWindowLoad = () => {
        this.applyTestPrice();
        this.render();
      };
      window.addEventListener('load', this.onWindowLoad, { once: true });
    }
  }

  disconnectedCallback() {
    this.picker?.removeEventListener('change', this.onVariantChange);
    if (this.onWindowLoad) window.removeEventListener('load', this.onWindowLoad);
  }

  /*
    ABConvert price test: swaps the base price for the price this visitor's test group
    pays for the selected variant. Left as rendered when there is no test for it.
    Mirrors updateAbconvertPriceForCurrentVariant() in global.js (main product form)
    and abconvertTestPrice() in cart.js (cart upsell) - keep the three in step if
    ABConvert changes its data.
  */
  applyTestPrice() {
    try {
      const variantId = this.variantInput?.value;
      const abData = window.abconvertPriceCartTransformTestDict?.[this.dataset.productId];
      if (!variantId || !abData?.experimentId) return;

      const countryCode = window.Shopify?.country;
      if (abData.filteredCountriesMap && countryCode && !abData.filteredCountriesMap[countryCode]) return;

      let groupIndex = 0;
      const testGroups = JSON.parse(localStorage.getItem('abconvert-experiment-to-group-index') || 'null');
      const assigned = testGroups?.[abData.experimentId];
      if (typeof assigned !== 'undefined') groupIndex = parseInt(assigned, 10);

      const priceObj = abData.variantToGroupIndexToPrice?.[variantId]?.[groupIndex];
      if (!priceObj) return;

      const groupPrice = (countryCode && priceObj.countryMap?.[countryCode]) || priceObj;
      if (groupPrice.price) this.dataset.price = Math.round(parseFloat(groupPrice.price) * 100);
    } catch {
      // No test price - keep the rendered one.
    }
  }

  onVariantChange() {
    const key = Array.from(this.picker.querySelectorAll('fieldset'))
      .map((fieldset) => fieldset.querySelector('input:checked')?.value)
      .join(' / ');

    const variant = this.variants[key];
    if (!variant) return;

    this.dataset.price = variant.price;
    this.dataset.comparePrice = variant.comparePrice;
    if (this.variantInput) this.variantInput.value = variant.id;
    this.applyTestPrice();

    if (this.button) this.button.disabled = !variant.available;
    if (this.label) this.label.textContent = variant.available ? this.addLabel : window.variantStrings.soldOut;

    this.render();
  }

  get kit() {
    return this.querySelector('product-kit');
  }

  render() {
    let total = Number(this.dataset.price) || 0;
    let compareTotal = Number(this.dataset.comparePrice) || 0;

    if (this.kit?.hasSelection) {
      compareTotal = (compareTotal || total) + this.kit.compareTotal;
      total += this.kit.total;
    }

    if (this.price) this.price.innerHTML = total > 0 ? window.formatMoney(total) : '';

    if (this.priceWrapper) this.priceWrapper.hidden = total <= 0;

    if (this.compare) {
      const showCompare = compareTotal > total;
      this.compare.innerHTML = showCompare ? window.formatMoney(compareTotal) : '';
      this.compare.hidden = !showCompare;
    }
  }
}

customElements.get('product-add-to-cart') || customElements.define('product-add-to-cart', ProductAddToCart);
